<template>
  <div class="container">
    <model-body :direction="direction"
                @clickPart="clickPart"></model-body>
    <div class="turn"
         @click="changeDirection">转身</div>
    <div class="point"
         :style="'display:' + point.display + ';left:' + point.x + 'px;top:' + point.y + 'px;'"></div>
  </div>
</template>

<script>
import ModelBody from './ModelBody.vue'

export default {
  name: 'ModelPart',
  props: {
    direction: {
      type: Number,
      default: 0
    }
  },
  components: {
    ModelBody
  },
  data() {
    return {
      minX: null,
      maxX: null,
      point: {
        display: 'none',
        x: -10,
        y: -10
      }
    }
  },
  mounted() {
    var screenHeight = document.body.clientHeight
    var screenWidth = document.body.clientWidth
    if (screenHeight && screenWidth) {
      var modelWidth = screenHeight / 2 - 16
      this.minX = (screenWidth - modelWidth) / 2
      this.maxX = screenWidth - this.minX
    }
  },
  methods: {
    showClick(e) {
      this.point = {
        x: e.clientX - 5,
        y: e.clientY - 55
      }
      if (this.point.x > this.minX && this.point.x < this.maxX) {
        this.point.display = 'block'
      } else {
        this.point.display = 'none'
      }
    },
    changeDirection() {
      this.point.display = 'none'
      this.$emit('change', 1 - this.direction, 2)
    },
    clickPart(e, id, name) {
      this.showClick(e)
      this.$emit('clickPart', id, name)
    }
  }
}
</script>

<style scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: white;
}

.point {
  position: absolute;
  z-index: 9;
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 5px;
  transform: scale(1);
  transition: all 0.3s;
}

.group {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: whitesmoke;
  border-radius: 30px;
  padding: 1px;
  overflow: hidden;
}

.group .item {
  flex: 1;
  min-width: 40px;
  text-align: center;
  line-height: 22px;
  color: black;
  font-size: 12px;
  border-radius: 22px;
}

.group .item.active {
  color: white;
  background-color: #0063aa;
}

.sex {
  position: absolute;
  left: 10px;
  top: 10px;
}

.stage {
  position: absolute;
  right: 10px;
  top: 10px;
}

.turn {
  position: absolute;
  right: 20px;
  bottom: 20px;
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 12px;
  color: white;
  border-radius: 40px;
  background-color: #0063aa;
}
</style>